import { FileTypeEnum as n } from "./index6.mjs";
import { FileSourceEnum as r } from "./index5.mjs";
const u = (t) => {
  if (typeof t != "object" || t === null) return !1;
  const e = t;
  return typeof e.id == "number" && typeof e.name == "string" && typeof e.filename == "string" && typeof e.path == "string" && (typeof e.thumbnail == "string" || e.thumbnail === null) && Object.values(r).includes(e.source) && typeof e.size == "number" && Object.values(n).includes(e.type) && typeof e.createdAt == "string";
};
export {
  u as isDataFileInterface
};
